import { render } from "./card.md?vue&type=template&id=78ff4656"
import script from "./card.md?vue&type=script&lang=js"
export * from "./card.md?vue&type=script&lang=js"
script.render = render

export default script